import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { LabelLargeBold, LabelSmall, Stack } from '../../../../../../../primitives/index.js';
import { SPACING_SMALL } from '../../../../../../../utils/spacingLegacy.js';
export const Caption = /*#__PURE__*/_styled(({
  title,
  subtitle,
  ...restProps
}) => _jsxs(Stack, {
  spacing: SPACING_SMALL,
  ...restProps,
  children: [_jsx(LabelLargeBold, {
    color: "contentInversePrimary",
    children: title
  }), _jsx(LabelSmall, {
    color: "contentInversePrimary",
    children: subtitle
  })]
}), process.env.NODE_ENV === "production" ? {
  target: "ejon0q90"
} : {
  target: "ejon0q90",
  label: "Caption"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcHRpb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWdTIiwiZmlsZSI6IkNhcHRpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgTGFiZWxMYXJnZUJvbGQsIExhYmVsU21hbGwsIFN0YWNrIH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vLi4vLi4vcHJpbWl0aXZlcy9pbmRleC5qcyc7XG5pbXBvcnQgeyBTUEFDSU5HX1NNQUxMIH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vLi4vLi4vdXRpbHMvc3BhY2luZ0xlZ2FjeS5qcyc7XG5leHBvcnQgY29uc3QgQ2FwdGlvbiA9IHN0eWxlZCgoeyB0aXRsZSwgc3VidGl0bGUsIC4uLnJlc3RQcm9wcyB9KSA9PiAoX2pzeHMoU3RhY2ssIHsgc3BhY2luZzogU1BBQ0lOR19TTUFMTCwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogW19qc3goTGFiZWxMYXJnZUJvbGQsIHsgY29sb3I6IFwiY29udGVudEludmVyc2VQcmltYXJ5XCIsIGNoaWxkcmVuOiB0aXRsZSB9KSwgX2pzeChMYWJlbFNtYWxsLCB7IGNvbG9yOiBcImNvbnRlbnRJbnZlcnNlUHJpbWFyeVwiLCBjaGlsZHJlbjogc3VidGl0bGUgfSldIH0pKSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1DYXB0aW9uLmpzLm1hcCJdfQ== */");